import React, { useState } from "react";
import ReactDOM from "react-dom";
import TextField from "@material-ui/core/TextField";
import {
  Typography,
  Button,
  Slider,
  Divider,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Card,
  CardMedia,
  IconButton,
  Box,
  Grid,
  FormControlLabel,
  Switch,
  Collapse,
  Tooltip,
  Checkbox,
  Tab,
  InputAdornment,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import DeleteIcon from "@material-ui/icons/Delete";
import { useTranslation } from "react-i18next";
import MDEditor from "@uiw/react-md-editor";
import remarkBreaks from "remark-breaks";
import InfoIcon from "@material-ui/icons/Info";
import ImageIcon from "@material-ui/icons/Image";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import MovieIcon from "@material-ui/icons/Movie";
import ThreeDRotation from "@material-ui/icons/ThreeDRotation";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import BlockIcon from "@material-ui/icons/Block";
import BrushIcon from "@material-ui/icons/Brush";
import CustomAlert from "../../components/CustomAlert/CustomAlert";

import ImageUtils from "../../../utils/imageUtils";
import TourHierarchyComponent from "../../components/TourHierarchy/TourHierarchyComponent";
import LoadingView from "../../components/loadingView";
import BreadcrumbTour from "../../components/breadcrumTour";
import UnsavedChangesIndicator from "../../components/unsevedChangesIndicator";
import InfoPopover from "../../../utils/informationButton";
import { Prompt } from "react-router-dom/cjs/react-router-dom.min";
import {
  AddBox,
  Map,
  PhoneAndroidOutlined,
  TabletAndroid,
} from "@material-ui/icons";
import SelectLocationDialog from "../../components/selectOnMapDialog";
import NoSubscriptionBanner from "../home/components/noSubscriptionBanner";
import DisableToursPopover from "../../../utils/disableToursPopover";
import TutorialBubble from "../../../utils/tutorialBubble";
import ImagePreviewContent from "../../components/imagePreview/ImagePreviewContent";
import SkeletonComponent from "../../components/Skeleton/SkeletonComponent";
import { ResponseTypeSelector } from "./newEnigmaTypes";

const NewEnigmaView = (props) => {
  const { t } = useTranslation();

  const unsavedChangesPortal = document.createElement("div");
  unsavedChangesPortal.style.position = "fixed";
  unsavedChangesPortal.style.top = "0";
  unsavedChangesPortal.style.left = "0";
  unsavedChangesPortal.style.width = "100%";
  unsavedChangesPortal.style.height = "100%";
  unsavedChangesPortal.style.pointerEvents = "none";
  unsavedChangesPortal.style.zIndex = "99999";
  document.body.appendChild(unsavedChangesPortal);

  function ValueLabelComponent(props) {
    const { children, open, value } = props;

    return (
      <Tooltip open={open} enterTouchDelay={0} placement="bottom" title={value}>
        {children}
      </Tooltip>
    );
  }

  const handleOpenAIModal = () => {
    props.handleOpenAIModal();
  };

  const handleCloseAIModal = () => {
    props.handleCloseAIModal();
  };

  const handleOpenAIImageModal = () => {
    props.handleOpenAIImageModal();
  };

  const handleCloseAIImageModal = () => {
    props.handleCloseAIImageModal();
  };

  const handleGenerateImageChange = (event) => {
    props.handleGenerateImageChange(event);
  };

  const handleGenerateEnigma = () => {
    props.handleGenerateEnigma();
  };

  const handleGenerateAIImage = () => {
    props.handleGenerateAIImage();
  };

  const toSyntheticEvent = (value) => ({
    preventDefault: () => { },
    target: { value },
  });

  return (
    <div className={props.classes.root}>
      {ReactDOM.createPortal(
        <UnsavedChangesIndicator
          show={props.state.unsavedChanges}
          style={
            {
              // position: "fixed",
              // top: "80px",
              // left: "50%",
              // transform: "translateX(-50%)",
              // marginRight: 200,
              // zIndex: 99999,
            }
          }
        />,
        unsavedChangesPortal
      )}
      <TourHierarchyComponent
        tourId={props.state.formDatas ? props.state.formDatas.tourId : null}
        currentZoneId={props.state.formDatas ? props.state.formDatas.zoneId : null}
        currentEnigmaId={
          props.state.formDatas && props.state.formDatas.enigmaId !== -1
            ? props.state.formDatas.enigmaId
            : null
        }
        role={props.state.role}
        tourDisabled={props.state.tourDisabled}
      />
      <div style={{ paddingBottom: 60 }} className={props.classes.mainContent}>
        <Prompt
          when={props.state.unsavedChanges}
          message={t("newEnigma.modificationsNonEnregistrees")}
        />
        <NoSubscriptionBanner
          role={props.state.role}
          redirectToSelectedPack={null}
          classes={props.classes}
        ></NoSubscriptionBanner>
        <DisableToursPopover
          userOpenedPopover={props.state.isDisableToursOpened}
        />
        <Container className={props.classes.formContainer} maxWidth={false}>
          <BreadcrumbTour
            tourId={props.state.formDatas.tourId}
            zoneId={props.state.formDatas.zoneId}
            enigmaId={props.state.formDatas.enigmaId}
            zoneMode={props.state.formDatas.zoneMode}
          />
          <br></br>
          <form
            className={props.classes.form}
            autoComplete="off"
            onSubmit={props.submitForm}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                {props.state.showSkeletonEnigma ? (
                  <SkeletonComponent type="blocks"></SkeletonComponent>
                ) : (
                  <>
                    <Box className={props.classes.headerBlock}>
                      <Box
                        className={props.classes.titleRow}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "16px",
                        }}
                      >
                        <Typography className={props.classes.enigmaTitle}>
                          {t("newEnigma.enigmaText")}
                          <span className="required">*</span>
                        </Typography>
                        <InfoPopover
                          title={t("newEnigma.texteEnigme")}
                          text={t("newEnigma.texteEnigmeInfo")}
                        ></InfoPopover>

                        <Button
                          variant="contained"
                          onClick={handleOpenAIModal}
                          className={props.classes.aiGenerateButton}
                          endIcon={
                            <Box
                              component="span"
                              style={{
                                fontSize: "24px",
                                animation: "pulse 2s infinite",
                              }}
                            >
                              ✨
                            </Box>
                          }
                        >
                          {t("generate_enigma_with_ai.title")}
                        </Button>
                      </Box>

                      <Box
                        className={props.classes.markdownEditorContainer}
                        data-color-mode="light"
                        style={{
                          "--md-edit-label": `"${t("markdown_editor.edit_label")}"`,
                          "--md-preview-label": `"${t("markdown_editor.preview_label")}"`,
                        }}
                      >
                        <MDEditor
                          id="enigma-text"
                          value={props.state.formDatas.title || ""}
                          onChange={(value) => {
                            const nextValue = value || "";
                            const e = toSyntheticEvent(nextValue);
                            props.updateEnigmaText(e);
                            props.updateTitle(e);
                          }}
                          preview="live"
                          highlightEnable={false}
                          height={220}
                          visibleDragbar={false}
                          textareaProps={{ maxLength: 1000 }}
                          previewOptions={{
                            remarkPlugins: [remarkBreaks],
                          }}
                          key={
                            props.state.enigmaLoaded
                              ? "enigmaTextLoaded"
                              : "enigmaTextNotLoaded"
                          }
                          commandsFilter={(command, isExtra) => {
                            if (command?.name === "fullscreen") return false;
                            return command;
                          }}
                        />
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                        style={{ marginBottom: "12px" }}
                      >
                        <Typography className={props.classes.markdownEditorHint}>
                          {t("markdown_editor.hint")}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "12px",
                            marginRight: "12px",
                            color: "#94A3B8",
                            textAlign: "right",
                          }}
                        >
                          {(props.state.formDatas.title || "").length}/1000
                        </Typography>
                      </Box>

                      {(props.state.formDatas.responseType != "teamPhoto")
                        && (
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "16px",
                              padding: "12px",
                              backgroundColor: "#F8FAFC",
                              borderRadius: "8px",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    props.state.formDatas.quizMode || false
                                  }
                                  onChange={props.updateQuizMode}
                                  style={{
                                    color: "#232C48",
                                  }}
                                />
                              }
                              label={
                                <Typography
                                  style={{
                                    fontSize: "14px",
                                    color: "#2c3e50",
                                    fontWeight: 500,
                                  }}
                                >
                                  {t("newEnigma.quizMode")}
                                </Typography>
                              }
                              style={{
                                marginLeft: 0,
                              }}
                            />
                            <InfoPopover
                              title={t("newEnigma.quizModeInfoTitle")}
                              text={t("newEnigma.quizModeInfoText")}
                            />
                          </Box>
                        )}



                      <FormControl
                        fullWidth
                        className={props.classes.responseTypeSelect}
                      >
                        <InputLabel id="response-type-label">
                          {t("newEnigma.responseType")}
                        </InputLabel>

                        <Select
                          labelId="response-type-label"
                          id="response-type"
                          value={props.state.formDatas.responseType || ""}
                          onChange={props.handleSelectResponseTypeChange}
                          label={t("newEnigma.responseType")}
                        >
                          <MenuItem value="text">
                            {t("newEnigma.text")}
                          </MenuItem>
                          <MenuItem value="picker">
                            {t("newEnigma.picker")}
                          </MenuItem>
                          <MenuItem value="multipleChoice">
                            {t("newEnigma.multipleChoice")}
                          </MenuItem>
                          <MenuItem value="recomposeWord">
                            {t("newEnigma.recomposeWord")}
                          </MenuItem>
                          <MenuItem value="compass">
                            {t("newEnigma.compass")}
                          </MenuItem>
                          <MenuItem value="switch">
                            {t("newEnigma.switch")}
                          </MenuItem>
                          <MenuItem value="potentiometer">
                            {t("newEnigma.potentiometer")}
                          </MenuItem>
                          <MenuItem value="teamPhoto">
                            {t("newEnigma.teamPhoto")}
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <ResponseTypeSelector {...props} />
                    </Box>
                  </>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {props.state.showSkeletonEnigma ? (
                  <SkeletonComponent type="blocks"></SkeletonComponent>
                ) : (
                  <>
                    <Box className={props.classes.rightColumn}>
                      <Box
                        className={props.classes.whiteBlock}
                        style={{
                          flex: 0.3,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "120px",
                        }}
                      >
                        <Box
                          className={props.classes.pointsBlock}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                            maxWidth: "300px",
                          }}
                        >
                          <Typography
                            className={props.classes.pointsTitle}
                            style={{ textAlign: "center" }}
                          >
                            {t("newEnigma.pointsToEarn")}
                            <span className="required">*</span>
                          </Typography>
                          <TextField
                            required
                            id="points"
                            variant="outlined"
                            type="number"
                            placeholder="23"
                            value={
                              props.state.formDatas.points ||
                                props.state.formDatas.points === 0
                                ? props.state.formDatas.points
                                : ""
                            }
                            onChange={props.updatePoints}
                            InputProps={{
                              inputProps: { min: 0 },
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Box
                                    component="span"
                                    className={props.classes.pointsIcon}
                                  >
                                    🏆
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                      </Box>
                      <Box
                        className={`${props.classes.whiteBlock} ${props.classes.mediaBlock}`}
                        style={{
                          flex: 0.7,
                          minHeight: "600px",
                          height: "100%",
                          padding: "20px",
                        }}
                      >
                        <Typography
                          className={props.classes.optionalTitle}
                          align="inherit"
                          gutterBottom
                          style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            marginBottom: "20px",
                          }}
                        >
                          {t("newEnigma.media_title")}
                        </Typography>
                        <FormControl
                          variant="outlined"
                          style={{
                            backgroundColor: "white",
                            marginBottom: 20,
                            marginTop: 0,
                            width: "100%",
                            borderRadius: "8px",
                          }}
                        >
                          <InputLabel
                            id="select-media-type"
                            shrink={!!props.state.formDatas.mediaType}
                            style={{
                              backgroundColor: "white",
                              padding: "0 5px",
                              transform: "translate(14px, -6px) scale(0.75)",
                            }}
                          >
                            {t("newEnigma.typeMedia")}
                          </InputLabel>

                          <Select
                            labelId="select-media-type"
                            id="select-media-type"
                            value={props.state.formDatas.mediaType}
                            onChange={props.handleSelectMediaTypeChange}
                            style={{
                              borderRadius: "8px",
                              height: "48px",
                            }}
                          >
                            <MenuItem
                              value={"none"}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 16px",
                              }}
                            >
                              <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={1.5}>
                                <RemoveCircleOutlineIcon
                                  style={{ color: "#9e9e9e", fontSize: "20px" }}
                                />
                                <Typography style={{ fontSize: "14px" }}>
                                  {t("newEnigma.enigmaTypeNone")}
                                </Typography>
                              </Box>
                            </MenuItem>
                            <MenuItem
                              value={"image"}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 16px",
                              }}
                            >
                              <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={1.5}>
                                <ImageIcon
                                  style={{ color: "#1976d2", fontSize: "20px" }}
                                />
                                <Typography style={{ fontSize: "14px" }}>
                                  {t("newEnigma.enigmaTypeImage")}
                                </Typography>
                              </Box>
                            </MenuItem>
                            <MenuItem
                              value={"youtube"}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 16px",
                              }}
                            >
                              <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={1.5}>
                                <VideoLibraryIcon
                                  style={{ color: "#d32f2f", fontSize: "20px" }}
                                />
                                <Typography style={{ fontSize: "14px" }}>
                                  {t("newEnigma.enigmaTypeVideoYoutube")}
                                </Typography>
                              </Box>
                            </MenuItem>
                            <MenuItem
                              value={"video"}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 16px",
                              }}
                            >
                              <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={1.5}>
                                <MovieIcon
                                  style={{ color: "#d97706", fontSize: "20px" }}
                                />
                                <Typography style={{ fontSize: "14px" }}>
                                  {t("newEnigma.enigmaTypeVideo")}
                                </Typography>
                              </Box>
                            </MenuItem>
                            <MenuItem
                              value={"ar"}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 16px",
                              }}
                            >
                              <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={1.5}>
                                <ThreeDRotation
                                  style={{ color: "#388e3c", fontSize: "20px" }}
                                />
                                <Typography style={{ fontSize: "14px" }}>
                                  {t("newEnigma.enigmaTypeAR")}
                                </Typography>
                              </Box>
                            </MenuItem>
                          </Select>
                        </FormControl>

                        {props.state.formDatas.mediaType === "image" && (
                          <Box
                            className={props.classes.boxOptional}
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderRadius: "12px",
                              padding: "24px",
                              marginTop: "20px",
                            }}
                          >
                            <Typography
                              className={props.classes.optionalTitle}
                              align="inherit"
                              gutterBottom
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "#2c3e50",
                                marginBottom: "16px",
                              }}
                            >
                              {t("newEnigma.image_enigma_title")}
                            </Typography>
                            <Box
                              className={props.classes.actionsRow}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                marginBottom: "24px",
                              }}
                            >
                              <Button
                                variant="contained"
                                color="secondary"
                                className={props.classes.uploadFile}
                                startIcon={
                                  <CloudUploadIcon
                                    style={{ fontSize: "20px" }}
                                  />
                                }
                                component="label"
                                style={{
                                  borderRadius: "8px",
                                  textTransform: "none",
                                  padding: "0 16px",
                                  height: "36px",
                                  minWidth: "120px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {t("newEnigma.upload_image_button")}
                                <input
                                  type="file"
                                  onChange={props.vintageImageSelected}
                                  hidden
                                  accept=".png,.jpg,.jpeg"
                                />
                              </Button>
                              <Button
                                variant="contained"
                                onClick={handleOpenAIImageModal}
                                className={props.classes.aiGenerateButton}
                                endIcon={
                                  <Box
                                    component="span"
                                    style={{
                                      fontSize: "20px",
                                      animation: "pulse 2s infinite",
                                    }}
                                  >
                                    ✨
                                  </Box>
                                }
                              >
                                {t("generate_enigma_with_ai.title")}
                              </Button>
                              <IconButton
                                className={props.classes.deleteIconButton}
                                edge="end"
                                aria-label="delete"
                                onClick={(e) => {
                                  props.deleteImage(false, true, false);
                                }}
                                style={{
                                  backgroundColor: "#fee2e2",
                                  padding: "0",
                                  height: "36px",
                                  width: "36px",
                                  minWidth: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <DeleteIcon
                                  style={{ color: "#dc2626", fontSize: "20px" }}
                                />
                              </IconButton>
                            </Box>

                            <Box
                              style={{
                                backgroundColor: "#e2e8f0",
                                borderRadius: "8px",
                                padding: "16px",
                                marginBottom: "24px",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: "14px",
                                  color: "#475569",
                                  lineHeight: "1.5",
                                }}
                                gutterBottom
                              >
                                {t("newEnigma.image_phone_dimensions")}
                                <br />
                                {t("newEnigma.image_tablet_dimensions")}
                              </Typography>
                            </Box>

                            {props.state.showVintageImageTooBig && (
                              <CustomAlert
                                severity="error"
                                message={t("newEnigma.image_too_big_error")}
                                duration={5000}
                                onClose={() => { }}
                                height={90}
                              />
                            )}

                            <Grid
                              item
                              xs={12}
                              direction="column"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                backgroundColor: "#ffffff",
                                borderRadius: "12px",
                                boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                                overflow: "hidden",
                              }}
                            >
                              <ImagePreviewContent
                                imageUrl={
                                  props.state.formDatas.vintage?.imageUrl
                                }
                                imageFile={
                                  props.state.formDatas.vintage?.imageFile
                                }
                                phoneWidth={822}
                                phoneHeight={964}
                                tabletWidth={2048}
                                tabletHeight={1996}
                              />
                            </Grid>
                          </Box>
                        )}

                        {props.state.formDatas.mediaType === "youtube" && (
                          <Box
                            className={props.classes.boxOptional}
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderRadius: "12px",
                              padding: "24px",
                              marginTop: "20px",
                            }}
                          >
                            <Typography
                              className={props.classes.optionalTitle}
                              align="inherit"
                              gutterBottom
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "#2c3e50",
                                marginBottom: "16px",
                              }}
                            >
                              {t("newEnigma.video_youtube_title")}
                            </Typography>
                            <Alert
                              severity="info"
                              style={{ borderRadius: 8, marginBottom: 16 }}
                            >
                              {t("newEnigma.video_youtube_info")}
                            </Alert>
                            <Box
                              style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "8px",
                                padding: "24px",
                                boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                              }}
                            >
                              <TextField
                                id="filled-required"
                                label={t("newEnigma.youtube_video_url_label")}
                                inputProps={{ maxLength: 255 }}
                                variant="outlined"
                                size="small"
                                style={{ minWidth: "400px", width: "100%" }}
                                className={props.classes.textfieldResponses}
                                multiline={true}
                                value={
                                  props.hasOtherMediaThanYT()
                                    ? ""
                                    : props.state.formDatas.youtubeVideoUrl
                                }
                                onChange={props.updateYoutubeVideoUrl}
                                key={
                                  props.state.enigmaLoaded
                                    ? "YTLoaded"
                                    : "YTNotLoaded"
                                }
                              />
                            </Box>
                          </Box>
                        )}

                        {props.state.formDatas.mediaType === "video" && (
                          <Box
                            className={props.classes.boxOptional}
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderRadius: "12px",
                              padding: "24px",
                              marginTop: "20px",
                            }}
                          >
                            <Typography
                              className={props.classes.optionalTitle}
                              align="inherit"
                              gutterBottom
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "#2c3e50",
                                marginBottom: "16px",
                              }}
                            >
                              {t("newEnigma.video_file_title")}
                            </Typography>

                            <Alert
                              severity="warning"
                              style={{ borderRadius: 8, marginBottom: 16 }}
                            >
                              {t("newEnigma.video_file_info")}
                            </Alert>

                            <Box
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                marginBottom: "16px",
                                flexWrap: "wrap",
                              }}
                            >
                              <Button
                                variant="contained"
                                color="secondary"
                                className={props.classes.uploadFile}
                                startIcon={
                                  <CloudUploadIcon style={{ fontSize: "20px" }} />
                                }
                                component="label"
                                style={{
                                  borderRadius: "8px",
                                  textTransform: "none",
                                  padding: "0 16px",
                                  height: "36px",
                                  minWidth: "160px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {t("newEnigma.upload_video_button")}
                                <input
                                  type="file"
                                  onChange={props.videoSelected}
                                  hidden
                                  accept="video/*"
                                />
                              </Button>

                              <Typography style={{ color: "#64748B", fontSize: 12 }}>
                                {t("newEnigma.video_max_size_info")}
                              </Typography>

                              <IconButton
                                className={props.classes.deleteIconButton}
                                edge="end"
                                aria-label="delete"
                                onClick={props.deleteVideo}
                                style={{
                                  backgroundColor: "#fee2e2",
                                  padding: "0",
                                  height: "36px",
                                  width: "36px",
                                  minWidth: "36px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <DeleteIcon
                                  style={{ color: "#dc2626", fontSize: "20px" }}
                                />
                              </IconButton>

                              <Typography style={{ color: "#64748B", fontSize: 13 }}>
                                {props.state.formDatas.video?.fileName ||
                                  props.state.formDatas.video?.file?.name ||
                                  props.state.formDatas.video?.url ||
                                  t("newEnigma.no_video_selected")}
                              </Typography>
                            </Box>

                            {props.state.showVideoTooBig && (
                              <CustomAlert
                                severity="error"
                                message={t("newEnigma.error_video_too_big")}
                                duration={5000}
                                onClose={() => { }}
                              />
                            )}

                            {(props.state.formDatas.video?.file ||
                              props.state.formDatas.video?.url) && (
                                <Box
                                  style={{
                                    backgroundColor: "#ffffff",
                                    borderRadius: "12px",
                                    boxShadow:
                                      "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                                    overflow: "hidden",
                                    padding: 16,
                                  }}
                                >
                                  <video
                                    controls
                                    style={{ width: "100%", maxHeight: "400px", borderRadius: 8 }}
                                    src={
                                      props.state.formDatas.video?.file
                                        ? URL.createObjectURL(
                                          props.state.formDatas.video.file
                                        )
                                        : props.state.formDatas.video?.url
                                    }
                                  />
                                </Box>
                              )}
                          </Box>
                        )}

                        {props.state.formDatas.mediaType === "ar" && (
                          <Box
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderRadius: "12px",
                              padding: "24px",
                              marginTop: "20px",
                            }}
                          >
                            <Alert
                              severity="warning"
                              style={{
                                marginBottom: "24px",
                                borderRadius: "8px",
                              }}
                            >
                              {t("newEnigma.fonctionnalite_beta_avertissement")}
                            </Alert>

                            <Box
                              className={props.classes.actionsRow}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                marginBottom: "24px",
                              }}
                            >
                              <Typography
                                className={props.classes.optionalTitle}
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 600,
                                  color: "#2c3e50",
                                }}
                              >
                                {t("newEnigma.3d_object_title")}
                              </Typography>
                              <Box
                                className={props.classes.beta}
                                style={{
                                  backgroundColor: "#fef3c7",
                                  color: "#92400e",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                }}
                              >
                                {t("newEnigma.beta_text")}
                              </Box>
                              <InfoPopover
                                title={t("newEnigma.ar_info_title")}
                                text={t("newEnigma.ar_info_text")}
                                src="/images/media-ar.webp"
                              />
                            </Box>

                            <Box
                              style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "8px",
                                padding: "24px",
                                boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                                marginBottom: "24px",
                              }}
                            >
                              <Box
                                className={props.classes.actionsRow}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "12px",
                                  marginBottom: "16px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  className={props.classes.uploadFile}
                                  startIcon={<CloudUploadIcon />}
                                  component="label"
                                  style={{
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    padding: "8px 16px",
                                  }}
                                >
                                  {t("newEnigma.upload_glb_button")}
                                  <input
                                    type="file"
                                    onChange={props.arObjectSelected}
                                    hidden
                                    accept=".glb"
                                  />
                                </Button>
                                <IconButton
                                  className={props.classes.deleteIconButton}
                                  edge="end"
                                  aria-label="delete"
                                  onClick={props.deleteObjFile}
                                  style={{
                                    backgroundColor: "#fee2e2",
                                    padding: "8px",
                                  }}
                                >
                                  <DeleteIcon style={{ color: "#dc2626" }} />
                                </IconButton>
                              </Box>

                              <Typography
                                style={{
                                  fontSize: "14px",
                                  color: "#475569",
                                  textAlign: "center",
                                  marginBottom: "8px",
                                }}
                              >
                                {t("newEnigma.max_file_size_glb")}
                              </Typography>

                              {props.state.showArObjectTooBig && (
                                <CustomAlert
                                  severity="error"
                                  message={t(
                                    "newEnigma.file_too_big_error_glb"
                                  )}
                                  duration={5000}
                                  onClose={() => { }}
                                  height={90}
                                />
                              )}

                              {(props.state.formDatas.arObject?.file ||
                                props.state.formDatas.arObject?.fileName) && (
                                  <Box
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      backgroundColor: "#f1f5f9",
                                      borderRadius: "6px",
                                      padding: "12px",
                                      marginTop: "16px",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "#475569",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {props.state.formDatas.arObject?.file
                                        ?.name ||
                                        props.state.formDatas.arObject?.fileName}
                                    </Typography>
                                  </Box>
                                )}
                            </Box>

                            <Box
                              style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "8px",
                                padding: "24px",
                                boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                              }}
                            >
                              <Box
                                className={props.classes.actionsRow}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "12px",
                                  marginBottom: "16px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  className={props.classes.uploadFile}
                                  startIcon={<CloudUploadIcon />}
                                  component="label"
                                  style={{
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    padding: "8px 16px",
                                  }}
                                >
                                  {t("newEnigma.upload_ar_image_button")}
                                  <input
                                    type="file"
                                    onChange={props.arImageRecognitionSelected}
                                    hidden
                                    accept=".png,.jpg,.jpeg"
                                  />
                                </Button>
                                <IconButton
                                  className={props.classes.deleteIconButton}
                                  edge="end"
                                  aria-label="delete"
                                  onClick={(e) =>
                                    props.deleteImage(false, false, true)
                                  }
                                  style={{
                                    backgroundColor: "#fee2e2",
                                    padding: "8px",
                                  }}
                                >
                                  <DeleteIcon style={{ color: "#dc2626" }} />
                                </IconButton>
                              </Box>

                              {props.state.showArRecognitionImageTooBig && (
                                <CustomAlert
                                  severity="error"
                                  message={t(
                                    "newEnigma.image_too_big_error_ar"
                                  )}
                                  duration={5000}
                                  onClose={() => { }}
                                  height={90}
                                />
                              )}

                              {(props.state.formDatas.arImageRecognition
                                ?.imageFile ||
                                props.state.formDatas.arImageRecognition
                                  ?.imageUrl) && (
                                  <Box
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: "40%",
                                        aspectRatio: "1",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                                      }}
                                    >
                                      <img
                                        className={
                                          props.classes.imageArRecognition
                                        }
                                        src={
                                          ImageUtils.getImageUrlFromFile(
                                            props.state.formDatas
                                              .arImageRecognition?.imageFile
                                          ) ||
                                          props.state.formDatas.arImageRecognition
                                            ?.imageUrl
                                        }
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>
                                  </Box>
                                )}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>

            <br />
            <Divider />
            <br />

            <Box
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "32px",
                marginBottom: "24px",
              }}
            >
              <Typography
                className={props.classes.sectionHeading}
                style={{
                  fontSize: "28px",
                  fontWeight: 700,
                  color: "#2c3e50",
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-8px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "40px",
                    height: "4px",
                    backgroundColor: "#3498db",
                    borderRadius: "2px",
                  },
                }}
              >
                Optionnel
              </Typography>
            </Box>

            <Box
              style={{
                backgroundColor: "#f8fafc",
                borderRadius: "16px",
                padding: "32px",
                width: "100%",
                boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                marginBottom: "32px",
              }}
            >
              <Typography
                className={props.classes.primaryOptionalTitle}
                style={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#2c3e50",
                  marginBottom: "24px",
                }}
              >
                {t("newEnigma.infos")}
              </Typography>

              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <Box
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "12px",
                      padding: "24px",
                      height: "100%",
                      boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "20px",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#2c3e50",
                        }}
                      >
                        {t("newEnigma.clue_title")}
                      </Typography>
                      <InfoPopover
                        title={t("newEnigma.clue_text_input_label")}
                        text={t("newEnigma.text_clue_markdown_description")}
                      />
                    </Box>

                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#2c3e50",
                        marginBottom: "12px",
                      }}
                    >
                      {t("newEnigma.clue_text_info")}
                    </Typography>

                    <Box
                      className={props.classes.markdownEditorContainer}
                      data-color-mode="light"
                      style={{
                        "--md-edit-label": `"${t("markdown_editor.edit_label")}"`,
                        "--md-preview-label": `"${t("markdown_editor.preview_label")}"`,
                      }}
                    >
                      <MDEditor
                        value={props.state.formDatas.clue?.title || ""}
                        onChange={(value) => {
                          props.updateClueTitle(toSyntheticEvent(value || ""));
                        }}
                        preview="live"
                        highlightEnable={false}
                        height={180}
                        visibleDragbar={false}
                        textareaProps={{ maxLength: 500 }}
                        previewOptions={{
                          remarkPlugins: [remarkBreaks],
                        }}
                        key={
                          props.state.enigmaLoaded
                            ? "clueTitleLoaded"
                            : "clueTitleNotLoaded"
                        }
                        commandsFilter={(command, isExtra) => {
                          if (command?.name === "fullscreen") return false;
                          return command;
                        }}
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                      style={{ marginBottom: "20px" }}
                    >
                      <Typography className={props.classes.markdownEditorHint}>
                        {t("markdown_editor.hint")}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "#94A3B8",
                          textAlign: "right",
                          marginRight: "12px",
                        }}
                      >
                        {(props.state.formDatas.clue?.title || "").length}/500
                      </Typography>
                    </Box>


                    <Box
                      className={props.classes.actionsRow}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "12px",
                        marginBottom: "20px",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        className={props.classes.uploadFile}
                        startIcon={<CloudUploadIcon />}
                        component="label"
                        style={{
                          borderRadius: "8px",
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        {t("newEnigma.upload_clue_image_button")}
                        <input
                          type="file"
                          onChange={props.clueImageSelected}
                          hidden
                          accept=".png,.jpg,.jpeg"
                        />
                      </Button>
                      <IconButton
                        className={props.classes.deleteIconButton}
                        edge="end"
                        aria-label="delete"
                        onClick={(e) => props.deleteImage(true, false, false)}
                        style={{
                          backgroundColor: "#fee2e2",
                          padding: "8px",
                        }}
                      >
                        <DeleteIcon style={{ color: "#dc2626" }} />
                      </IconButton>
                    </Box>

                    <Box
                      style={{
                        backgroundColor: "#f1f5f9",
                        borderRadius: "8px",
                        padding: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "14px",
                          color: "#475569",
                          lineHeight: "1.5",
                        }}
                      >
                        {t("newEnigma.clue_image_phone_dimensions")}
                        <br />
                        {t("newEnigma.clue_image_tablet_dimensions")}
                      </Typography>
                    </Box>

                    {props.state.showClueImageTooBig && (
                      <CustomAlert
                        severity="error"
                        message={t("newEnigma.clue_image_max_size_info")}
                        duration={5000}
                        onClose={() => { }}
                        height={90}
                      />
                    )}

                    {(props.state.formDatas.clue?.imageFile ||
                      props.state.formDatas.clue?.imageUrl) && (
                        <Box
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
                            marginBottom: "24px",
                          }}
                        >
                          <ImagePreviewContent
                            imageUrl={props.state.formDatas.clue?.imageUrl}
                            imageFile={props.state.formDatas.clue?.imageFile}
                            phoneWidth={410}
                            phoneHeight={700}
                            tabletWidth={1152}
                            tabletHeight={1308}
                            backgoundSize="contain"
                          />
                        </Box>
                      )}

                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#2c3e50",
                        marginBottom: "16px",
                      }}
                    >
                      {t("newEnigma.clue_timer_label")}
                    </Typography>

                    <Box
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "8px",
                        padding: "16px",
                        marginBottom: "24px",
                        boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
                      }}
                    >
                      <Slider
                        onChange={props.updateClueTime}
                        value={props.state.formDatas.clue?.timer}
                        aria-labelledby="discrete-slider"
                        valueLabelFormat={(value) => `${value} minutes`}
                        valueLabelDisplay="on"
                        ValueLabelComponent={ValueLabelComponent}
                        step={1}
                        marks
                        min={0}
                        max={30}
                        style={{ width: "100%" }}
                        key={
                          props.state.enigmaLoaded
                            ? "timerClueNotLoaded"
                            : "timerClueLoaded"
                        }
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "12px",
                      padding: "24px",
                      height: "100%",
                      boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "24px",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#2c3e50",
                        }}
                      >
                        {t("newEnigma.finish_text_title")}
                      </Typography>
                      <InfoPopover
                        title={t("newEnigma.finish_text_title")}
                        text={t("newEnigma.text_finish_enigma_description")}
                      />
                    </Box>

                    <FormControl
                      style={{
                        width: "100%",
                        marginBottom: "24px",
                        marginLeft: "8px",
                      }}
                    >
                      <InputLabel variant="outlined">
                        {t("newEnigma.finish_text_display_label")}
                      </InputLabel>
                      <Select
                        value={props.state.formDatas.showFinishTextOnLoose}
                        onChange={props.updateShowFinishOnLoose}
                        label={t("newEnigma.finish_text_display_label")}
                        style={{
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <MenuItem value={true}>
                          {t("newEnigma.finish_text_display_option_both")}
                        </MenuItem>
                        <MenuItem value={false}>
                          {t("newEnigma.finish_text_display_option_success")}
                        </MenuItem>
                      </Select>
                    </FormControl>

                    <Typography
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#2c3e50",
                        marginBottom: "12px",
                      }}
                    >
                      {t("newEnigma.text_finish_enigma_label")}
                    </Typography>

                    <Box
                      className={props.classes.markdownEditorContainer}
                      data-color-mode="light"
                      style={{
                        "--md-edit-label": `"${t("markdown_editor.edit_label")}"`,
                        "--md-preview-label": `"${t("markdown_editor.preview_label")}"`,
                      }}
                    >
                      <MDEditor
                        value={props.state.formDatas.finishText || ""}
                        onChange={(value) => {
                          props.updateFinishText(toSyntheticEvent(value || ""));
                        }}
                        preview="live"
                        highlightEnable={false}
                        height={180}
                        visibleDragbar={false}
                        textareaProps={{ maxLength: 500 }}
                        previewOptions={{
                          remarkPlugins: [remarkBreaks],
                        }}
                        key={
                          props.state.enigmaLoaded
                            ? "finishTextLoaded"
                            : "finishTextNotLoaded"
                        }
                        commandsFilter={(command, isExtra) => {
                          if (command?.name === "fullscreen") return false;
                          return command;
                        }}
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                    >
                      <Typography className={props.classes.markdownEditorHint}>
                        {t("markdown_editor.hint")}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "#94A3B8",
                          textAlign: "right",
                          marginRight: "12px",
                        }}
                      >
                        {(props.state.formDatas.finishText || "").length}/500
                      </Typography>
                    </Box>

                  </Box>
                </Grid>
              </Grid>
            </Box>

            <br />
            {props.state.showError ? (
              <CustomAlert
                severity="error"
                message={props.state.errorMessage}
                duration={5000}
                onClose={props.resetErrorAlert}
                height={90}
              />
            ) : null}
            {props.state.showSuccess ? (
              <CustomAlert
                severity="success"
                message={props.state.successMessage}
                duration={3000}
                onClose={props.resetSuccessAlert}
                height={90}
              />
            ) : null}
            <br />
            <div ref={props.state.endOfPageRef} />
            <LoadingView
              className={props.classes.loadingView}
              open={props.state.loadingViewOpened}
            />
            <Box
              className={props.classes.actionBar}
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "16px 16px 16px 16px",
                background:
                  "linear-gradient(to top, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.1) 65%, rgba(0, 0, 0, 0) 100%)",
                backdropFilter: "blur(12px)",
                WebkitMaskImage:
                  "linear-gradient(to top, black 0%, black 65%, transparent 100%)",
                maskImage:
                  "linear-gradient(to top, black 0%, black 65%, transparent 100%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                zIndex: 1000,
                boxShadow: "0 -1px 3px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Link
                className={props.classes.returnButtonLink}
                to={`/zone?tourId=${props.state.formDatas.tourId}&zoneId=${props.state.formDatas.zoneId}`}
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="outlined"
                  color="darkGrey"
                  style={{
                    minWidth: "120px",
                    height: "36px",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "0 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  {t("newEnigma.return_button")}
                </Button>
              </Link>
              <Button
                variant="contained"
                color="primary"
                className={`${props.classes.saveButton} ${props.state.role === "NO_SUBSCRIBTION" ||
                  props.state.tourDisabled
                  ? props.classes.buttonDisabled
                  : ""
                  }`}
                // onClick={props.submitForm}
                type="submit"
                style={{
                  minWidth: "120px",
                  height: "36px",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "0 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {props.state.editing ? (
                  <div>{t("newEnigma.save_button")}</div>
                ) : (
                  <div>{t("newEnigma.add_button")}</div>
                )}
              </Button>
            </Box>
          </form>
          {/* TUTO DÉSACTIVÉ - à réactiver si besoin
          {props.state.tutorialSteps?.step4 == false && (
            <TutorialBubble
              style={{ position: "absolute" }}
              message={t("tuto.step4")}
            ></TutorialBubble>
          )}
          {props.state.tutorialSteps?.step5 == false &&
            props.state.tutorialSteps?.step1 == true &&
            props.state.tutorialSteps?.step2 == true &&
            props.state.tutorialSteps?.step3 == true &&
            props.state.tutorialSteps?.step4 == true && (
              <TutorialBubble
                style={{ position: "absolute" }}
                message={`${t("tuto.step5Part1")}${props.state.testCode ? props.state.testCode : ""
                  }${t("tuto.step5Part2")}`}
              ></TutorialBubble>
            )}
          */}
        </Container>
        {/* AR avec localisation (pas disponible sur téléphone pour le moment) */}
        {/* <SelectLocationDialog
        type="AR_OBJECT"
        lat={props.showLatOnMap}
        lng={props.showLngOnMap}
        open={props.mapDialogOpen}
        zoneLng={props.state.zoneLng}
        zoneLat={props.state.zoneLat}
        zoneRadius={props.state.zoneRadius}
        initLocationLat={
          props.state.formDatas.coordsLatitudeArObject
            ? props.state.formDatas.coordsLatitudeArObject
            : props.state.currentZone?.coordsLatitude
        }
        initLocationLng={
          props.state.formDatas.coordsLongitudeArObject
            ? props.state.formDatas.coordsLongitudeArObject
            : props.state.currentZone?.coordsLongitude
        }
        onClose={() => props.closeMapDialog()}
        onLocationSelected={(location, type) => {
          props.setArObjectLocation(location);
        }}
      />{" "} */}
        <Dialog
          open={props.state.openAIModal}
          onClose={handleCloseAIModal}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              background:
                "linear-gradient(145deg, rgba(255,255,255,0.95), rgba(255,255,255,0.9))",
              backdropFilter: "blur(10px)",
              borderRadius: "20px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
            },
          }}
        >
          <DialogTitle>
            <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={2}>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  background: "linear-gradient(135deg, #FF0080, #7928CA)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {t("newEnigma.generate_with_ai.dialog_title")}
              </Typography>
              <Box
                component="span"
                style={{
                  fontSize: "28px",
                  animation: "pulse 2s infinite",
                }}
              >
                {" 🤖"}
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box mb={3}>
              <Typography
                style={{
                  fontSize: "16px",
                  color: "#666",
                  marginBottom: "20px",
                  lineHeight: 1.6,
                }}
              >
                {t("newEnigma.generate_with_ai.enigma_description")}
              </Typography>
              <TextField
                autoFocus
                multiline
                rows={4}
                variant="outlined"
                placeholder={t("newEnigma.generate_with_ai.enigma_placeholder")}
                fullWidth
                value={props.state.textPrompt}
                onChange={props.handlePromptChange}
                inputProps={{ maxLength: 500 }}
                style={{
                  background: "rgba(255,255,255,0.9)",
                  borderRadius: "12px",
                  marginBottom: "20px",
                }}
              />
              <Typography
                style={{
                  fontSize: "12px",
                  color: "#9CA3AF",
                  textAlign: "right",
                  marginTop: "-12px",
                  marginBottom: "12px",
                }}
              >
                {(props.state.textPrompt || "").length}/500
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.state.generateImage}
                    onChange={handleGenerateImageChange}
                    style={{
                      color: "#7928CA",
                      "&.Mui-checked": {
                        color: "#7928CA",
                      },
                    }}
                  />
                }
                label={
                  <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={1}>
                    <Typography
                      style={{
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      {t("newEnigma.generate_with_ai.generate_image_checkbox")}
                    </Typography>
                    <Box
                      component="span"
                      style={{
                        fontSize: "20px",
                        animation: props.state.generateImage
                          ? "pulse 2s infinite"
                          : "none",
                      }}
                    >
                      {" 🎨"}
                    </Box>
                  </Box>
                }
                style={{
                  marginTop: "8px",
                  background: "rgba(124, 58, 237, 0.05)",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  marginLeft: 0,
                  width: "100%",
                }}
              />
            </Box>
            <Box
              style={{
                background: "rgba(124, 58, 237, 0.05)",
                borderRadius: "12px",
                padding: "16px",
                marginBottom: "20px",
              }}
            >
              <Typography
                style={{
                  fontSize: "14px",
                  color: "#666",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span style={{ fontSize: "20px" }}>{"💡 "}</span>
                {t("newEnigma.generate_with_ai.enigma_tip")}
              </Typography>
            </Box>

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "20px",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(255,255,255,0.8))",
                  borderRadius: "12px",
                  padding: "12px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{"💰 "}</span>
                  {t("newEnigma.generate_with_ai.generation_cost")}{" "}
                  <span style={{ fontWeight: 600, color: "#7928CA" }}>
                    {props.state.generateImage ? "6" : "1"}
                  </span>{" "}
                  {t("newEnigma.generate_with_ai.credits")}
                </Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(255,255,255,0.8))",
                  borderRadius: "12px",
                  padding: "12px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{"⚡️ "}</span>
                  {t("newEnigma.generate_with_ai.remaining_credits")}{" "}
                  <span style={{ fontWeight: 600, color: "#7928CA" }}>
                    {" "}
                    {props.state.aiCredits}
                  </span>
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px" }}>
            <Button
              onClick={handleCloseAIModal}
              style={{
                color: "#666",
                textTransform: "none",
              }}
            >
              {t("newEnigma.generate_with_ai.cancel")}
            </Button>
            <Button
              className={props.classes.aiDialogPrimary}
              variant="contained"
              style={{
                background: "linear-gradient(135deg, #FF0080, #7928CA)",
                color: "white",
                textTransform: "none",
                borderRadius: "8px",
                padding: "8px 24px",
                boxShadow: "0 4px 15px rgba(124, 58, 237, 0.2)",
              }}
              onClick={() => {
                handleGenerateEnigma();
              }}
              disabled={props.state.loading}
            >
              {props.state.loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t("newEnigma.generate_with_ai.generate")
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={props.state.openAIImageModal}
          onClose={handleCloseAIImageModal}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              background:
                "linear-gradient(145deg, rgba(255,255,255,0.95), rgba(255,255,255,0.9))",
              backdropFilter: "blur(10px)",
              borderRadius: "20px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
            },
          }}
        >
          <DialogTitle>
            <Box className={props.classes.inlineGap} display="flex" alignItems="center" gap={2}>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  background: "linear-gradient(135deg, #FF0080, #7928CA)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {t("newEnigma.generate_image.dialog_title")}
              </Typography>
              <Box
                component="span"
                style={{
                  fontSize: "28px",
                  animation: "pulse 2s infinite",
                }}
              >
                {" 🎨"}
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box mb={3}>
              <Typography
                style={{
                  fontSize: "16px",
                  color: "#666",
                  marginBottom: "20px",
                  lineHeight: 1.6,
                }}
              >
                {t("newEnigma.generate_image.image_description")}
              </Typography>
              <TextField
                autoFocus
                multiline
                rows={4}
                variant="outlined"
                placeholder="Ex: Une illustration mystérieuse d'un vieux grimoire ouvert avec des symboles alchimiques, dans un style médiéval..."
                fullWidth
                value={props.state.imagePrompt}
                onChange={props.handleImagePromptChange}
                inputProps={{ maxLength: 500 }}
                style={{
                  background: "rgba(255,255,255,0.9)",
                  borderRadius: "12px",
                  marginBottom: "20px",
                }}
              />
              <Typography
                style={{
                  fontSize: "12px",
                  color: "#9CA3AF",
                  textAlign: "right",
                  marginTop: "-12px",
                  marginBottom: "12px",
                }}
              >
                {(props.state.imagePrompt || "").length}/500
              </Typography>
            </Box>
            <Box
              style={{
                background: "rgba(124, 58, 237, 0.05)",
                borderRadius: "12px",
                padding: "16px",
                marginBottom: "20px",
              }}
            >
              <Typography
                style={{
                  fontSize: "14px",
                  color: "#666",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span style={{ fontSize: "20px" }}>{"💡 "}</span>
                {t("newEnigma.generate_image.image_tip")}
              </Typography>
            </Box>

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "20px",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(255,255,255,0.8))",
                  borderRadius: "12px",
                  padding: "12px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{"💰 "}</span>
                  {t("newEnigma.generate_image.generation_cost")}{" "}
                  <span style={{ fontWeight: 600, color: "#7928CA" }}>5</span>{" "}
                  {t("newEnigma.generate_image.credits")}
                </Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,0.9), rgba(255,255,255,0.8))",
                  borderRadius: "12px",
                  padding: "12px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
              >
                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#666",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{"⚡️ "}</span>
                  {t("newEnigma.generate_image.remaining_credits")}{" "}
                  <span style={{ fontWeight: 600, color: "#7928CA" }}>
                    {props.state.aiCredits}
                  </span>
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions style={{ padding: "16px 24px" }}>
            <Button
              onClick={handleCloseAIImageModal}
              style={{
                color: "#666",
                textTransform: "none",
              }}
            >
              {t("newEnigma.generate_image.cancel")}
            </Button>
            <Button
              className={props.classes.aiDialogPrimary}
              variant="contained"
              style={{
                background: "linear-gradient(135deg, #FF0080, #7928CA)",
                color: "white",
                textTransform: "none",
                borderRadius: "8px",
                padding: "8px 24px",
                boxShadow: "0 4px 15px rgba(124, 58, 237, 0.2)",
              }}
              onClick={handleGenerateAIImage}
              disabled={props.state.loading}
            >
              {props.state.loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                t("newEnigma.generate_image.generate")
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default NewEnigmaView;
